import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7316e144"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7316e144')) {
      api.createRecord('7316e144', component.options)
    } else {
      api.reload('7316e144', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=7316e144", function () {
      api.rerender('7316e144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Distributors/pages/Index.vue"
export default component.exports